import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/api/`,

  // Resolve only if the status code is less than 400
  validateStatus: (status) => status < 400,
});

api.interceptors.response.use(
  (res) => Promise.resolve(res.data),
  (error) => Promise.reject(error.response.data || error),
);

export default api;
